<template>
  <el-container class="h-screen bg-white">
    <el-header height="auto">
      <el-tabs v-model="activeName" class="page-tabs" @tab-change="onChange">
        <el-tab-pane label="补丁申请" name="/version" />
        <el-tab-pane label="任务看板" name="/task" />
        <el-tab-pane v-if="weekTodoPerm" label="纯前端看板" name="/frond-todo" />
        <el-tab-pane v-if="weekTodoPerm" label="需求进度" name="/story-progress" />
        <el-tab-pane v-if="weekTodoPerm" label="需求看板" name="/story-kanban" />
        <!--<el-tab-pane label="需求看板" name="/story" />-->
      </el-tabs>
    </el-header>
    <el-main>
      <main class="h-full">
        <router-view />
      </main>
    </el-main>
    <VTooltipComp />
  </el-container>
</template>

<script setup lang="ts">
import { useStorage } from '@vueuse/core'
import { useRouter } from 'vue-router'

import { VTooltipComp } from '@/directive/v-tooltip'

defineOptions({
  name: 'App'
})

const router = useRouter()
const currentPath = computed(() => unref(router.currentRoute).path)

const activeName = ref(unref(currentPath))

watch(currentPath, path => {
  if (path !== unref(activeName)) {
    activeName.value = path
  }
})

const weekTodoPerm = useStorage('week-todo-perm', false)

function onChange(path: string) {
  router.push(path)
}
</script>

<style scoped lang="scss">
.page-tabs :deep(.el-tabs__header) {
  margin-bottom: 0;
}
</style>
